import gql from 'graphql-tag'

export const coachingLeadViewedMutation = gql`
  mutation CoachingLeadViewed($id: ID!) {
    CoachingLeadViewed(inquiryId: $id) {
      message
      success
      leadId
    }
  }
`

export const setCoachingLeadContactMutation = gql`
  mutation SetCoachingLeadContact(
    $id: ID!
    $contactMethod: CoachingLeadContactMethodEnum!
  ) {
    setCoachingLeadContact(inquiryId: $id, contactMethod: $contactMethod) {
      success
      message
      coachingInquiry {
        id
        contactMethod
        contactedAt
      }
    }
  }
`
